import { render, staticRenderFns } from "./HTML.vue?vue&type=template&id=2be183aa&"
import script from "./HTML.vue?vue&type=script&lang=js&"
export * from "./HTML.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports